<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="showForm(null)">新增</el-button>
      </template>
      <el-form
        :model="searchForm"
        ref="formData"
        inline
        class="global-form-label-width account-form"
        label-width="100px"
      >
        <el-form-item label="类型名称" prop="typeName">
          <el-input
            clearable
            v-model="searchForm.typeName"
            placeholder="请输入类型名称"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini"  stripe  default-expand-all border v-loading="loading" :data="typeTreeList" row-key="typeId" :tree-props="{children: 'childNode'}">

        <el-table-column
          min-width="120"
          label="类型名称"
          prop="typeName"
        ></el-table-column>

        <el-table-column min-width="120" label="类型图片" prop="typeImage">
          <template v-slot="{ row }">
            <el-image
            v-if="row.typeImage"
              style="width: 60px; height: 60px"
              :src="row.typeImage"
              :preview-src-list="[row.typeImage]"
              fit="cover"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column
          min-width="120"
          label="创建时间"
          prop="ctime"
        ></el-table-column> -->

        <el-table-column width="250" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button
              type="text"
              @click="
                $router.push('/grainType/edit?typeId=' + row.typeId)
              "
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="
                $router.push('/grainType/detail?typeId=' + row.typeId)
              "
              >详情</el-button
            >
            <el-button type="text" class="del-btn" @click="onDelete(row.typeId)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- <el-pagination
        class="mt15"
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination> -->
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'GrainType',
  mixins: [keepAlive],
  data () {
    return {
      typeTreeList: [],
      tableData: [],

      page: 1,
      total: 0,
      loading: false,
      searchForm: {

        typeName: ''
      },
      dialogVisible: false

    }
  },
  created () {
    // this.loadData()
    this.loadGrainTreeList()
  },
  computed: {

  },
  methods: {
    loadGrainTreeList() {
      this.$axios.get(this.$apis.grainType.selectYxOilTypeByTree).then(res => {
        this.typeTreeList = res
      })
    },
    loadData () {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.grainType.selectYxOilTypeByList, {
          params: params
        })
        .then(res => {
          this.tableData = res.list || []
          this.total = res.total || 0
        })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    onReset () {
      this.$refs.formData.resetFields()
    },
    showForm () {
      this.$router.push('/grainType/add')
    },
    onDelete (typeId) {
      this.$confirm('确认删除该粮油类型?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios
          .post(this.$apis.grainType.deleteYxOilType, {
            typeId
          })
          .then(() => {
            this.loadData()
          })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
